import firebase from './firebase';
import { firestore } from './firebase';
import { v4 as _UUID } from 'uuid';
import { push, location } from 'svelte-spa-router'

export function UUID()
{
    return _UUID().replace(/-/g, '');
}

export function Now()
{
    return new Date().getTime()/1000;
}

let logSession = [];
export function BeginLogSession()
{
    // clear things out on load
    logSession = [];
    log('START');
}

export function SendLogSession()
{
    // if we are on the local host don't log for sure
    if (window.location.hostname === 'localhost')
        return;

    // Save this to firestore or something
    const uid = UUID();
    const now = Now();
    firestore.collection('Logs').doc(uid).set({created:now, lastmod:now, data:JSON.stringify(logSession)}).then(() => {
    })
    .catch((error) =>
    {
        console.log('error sending stuff', error);
    })
    .then(() =>
    {
        logSession = [];
    });
}

export function log(...args)
{
    let now = Now()
    let user = firebase.auth().currentUser;
    user = user ? user.uid : 'nouser';

    console.log(new Date(now*1000), user, ...args); 
    
    logSession.push([user, ...args]);

    // limit the length of the stuff to.... something
    if (logSession.length > 10)
        logSession.shift();
}

export function error(...args)
{
    log(...args);
    SendLogSession();
}

export function RequestSignIn(returnTo, query)
{
    log('RequestSignIn', returnTo);
    if (returnTo)
    {
        if (query)
        {
            push(`/signin?rt=${returnTo}&${query}`);
        }
        else
        {
            push(`/signin?rt=${returnTo}`);
        }
    }
    else
        push('/signin');
}

window.onerror = function (message, file, line, col, err) {
    error("Uncaught", message, file, line, col, err)
    return false;
};

window.addEventListener('unhandledrejection', function (e) {
    error("Unhandled", e.reason.message);
})


